var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBook = function SvgBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 429.623 429.623",
    style: {
      enableBackground: "new 0 0 429.623 429.623"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.512,77.34c-48.64-25.088-105.984-25.088-154.624-0.512L8.192,92.188C3.072,94.748,0,99.868,0,106.012v249.856    c0,8.704,6.656,15.36,15.36,15.36c2.56,0,4.608-0.512,7.168-1.536l29.696-15.36c39.424-20.48,86.528-20.48,125.952,0    l21.504,11.264V80.924L192.512,77.34z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#4B7804"
    },
    "data-old_color": "#000000"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421.888,92.188l-29.696-15.36c-48.64-24.576-105.984-24.576-154.112,0l-7.68,3.584v284.16l21.504-10.752    c39.424-20.48,86.528-20.48,125.952,0l29.696,15.36c7.68,4.096,16.896,1.024,20.48-6.656c1.024-2.048,1.536-4.608,1.536-7.168    V106.012C430.08,99.868,427.008,94.748,421.888,92.188z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#4B7804"
    },
    "data-old_color": "#000000"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book.538fb505.svg";
export { ForwardRef as ReactComponent };